import ConfirmDialog from "modules/Common/Components/ConfirmDialog";
import whiteRoy from "../../../assets/img/icons/whiteRoy.svg";
import React from "react";
import { assetinDraftAlreadyExistClose } from "../actions";
import styled from "styled-components";

function AlreadyExistPopup() {
  const onCancel = () => {
    assetinDraftAlreadyExistClose();
  };

  return (
    <Wrapper>
      <ConfirmDialog
        confirm="Ok"
        onConfirm={onCancel}
        icon={whiteRoy}
        title="This article was already curated to this Edition. It will not be added."
        titleQuestion=""
        description="We’re sending your email to your recipients and lists. It may take time for all recipients to receive the email, but sit tight — it won’t take long…"
      />
    </Wrapper>
  );
}

export default AlreadyExistPopup;

const Wrapper = styled.div`
  height: 100vh;
  width: 100%;
  position: absolute;
  z-index: 1;
`;
